export { InsuredTourist } from "./components/InsuredTourist";
export { InsuredTouristsList } from "./components/InsuredTouristsList";
